import requestWithBaseURL from 'client/utils/request'
import { CalculatedPrice } from 'common/types/pricingTypes'
import {
  CalculatePriceData,
  GetShippingRules,
  ShippingResponse,
} from 'common/types/shippingType'
import { request } from 'src/editor/shared/utils/request'

export const getShippingRules = (
  data: GetShippingRules,
  abortSignal?: AbortSignal,
) =>
  requestWithBaseURL.post<ShippingResponse>(
    `${process.env.SYSTEME_IO_HOST}/api/payment/shipping-rules`,
    data,
    {
      signal: abortSignal,
    },
  )

export const calculatePrice = (
  data: CalculatePriceData[],
  abortSignal?: AbortSignal,
) =>
  request.post<CalculatedPrice[]>('/api/payment/calculate-price', data, {
    signal: abortSignal,
  })
